var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.666687C13.5837 0.666687 17.3337 4.41669 17.3337 9.00002C17.3337 13.5834 13.5837 17.3334 9.00033 17.3334C4.41699 17.3334 0.666992 13.5834 0.666992 9.00002C0.666992 4.41669 4.41699 0.666687 9.00033 0.666687ZM9.00033 2.33335C7.41699 2.33335 6.00033 2.83335 4.91699 3.75002L14.2503 13.0834C15.0837 11.9167 15.667 10.5 15.667 9.00002C15.667 5.33335 12.667 2.33335 9.00033 2.33335ZM13.0837 14.25L3.75033 4.91669C2.83366 6.00002 2.33366 7.41669 2.33366 9.00002C2.33366 12.6667 5.33366 15.6667 9.00033 15.6667C10.5837 15.6667 12.0003 15.1667 13.0837 14.25Z",
    fill: "#16054E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.a69e92302834d77bc702ae4347cf2d95.svg";
export { ForwardRef as ReactComponent };